"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RatingFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const number_1 = require("../../type-checking/number");
const get_value_1 = require("./get-value");
class RatingFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, number_1.isIntegerValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getRatingEmptyValue)();
    }
}
exports.RatingFieldValueGetter = RatingFieldValueGetter;
